import axios from "axios";

export default class SettingsApi {
  constructor(apiUrl) {
    this.client = axios.create();
    this.client.defaults.baseURL = apiUrl;
    this.client.defaults.headers["Content-Type"] = "application/json";
    this.client.defaults.withCredentials = true;
    this.client.timeout = 3000;
  }

  enableNtfFeed = () => this.client.put("/v1.3/user/receive_web_push/true");

  disableNtfFeed = () => this.client.put("/v1.3/user/receive_web_push/false");
}
